import React from "react";

function Soda() {
  return (
    <div class="wrapper" id="menu">
      <div class="title">
        <h4 style={{ textAlign: "center" }}>
          <span>
            voici Nos Boissons N'hésitez pas appelez le 09 50 85 13 53
          </span>
          Boissons{" "}
        </h4>
      </div>
      <div class="menu">
        <div class="single-menu">
          <img
            src="https://urbanburger-lille.fr/wp-content/uploads/2018/06/Boisson33cl-450x450.png"
            alt=""
          />
          <div class="menu-content">
            <h4>
              {" "}
              Boisson 33cl <span>1.5€</span>
            </h4>
          </div>
        </div>
        <div class="single-menu">
          <img
            src="https://www.ofreropizza.com/wp-content/uploads/2017/12/Oasis2L-300x300.jpg"
            alt=""
          />
          <div class="menu-content">
            <h4>
              Boisson 1.5cl <span>3.5€</span>
            </h4>
          </div>
        </div>
        <div class="single-menu">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/A_small_cup_of_coffee.JPG/280px-A_small_cup_of_coffee.JPG"
            alt=""
          />
          <div class="menu-content">
            <h4>
              Café <span>1.5€</span>
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Soda;
